export function disableImageMove(props) {
  if (props.isSpineText || !props.isMoveable) {
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/helpers/textHelper.js